import React from "react";
import ReactGA from "react-ga4";
import { useTranslation } from "react-i18next";

import { canEditFacilityBasicInfo } from "./utils";
import { useMe } from "../../../hooks/queries";
import { LocationData } from "../../../models/LocationData";
import { EditProfileFormSectionKeys } from "../EditProfileForm/const";

interface IEditProfileButtonProps {
  onOpenModal: (
    accordionEventKey?: EditProfileFormSectionKeys | null | undefined
  ) => void;
  gbpLink?: string;
  locationData: LocationData;
  accordionEventKey?: EditProfileFormSectionKeys | null | undefined;
}

export const EditProfileButton: React.FunctionComponent<
  IEditProfileButtonProps
> = (props) => {
  const { onOpenModal, gbpLink, locationData, accordionEventKey } = props;

  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityDetailsPage.basicChecklist.editProfileButton.${key}`);

  const { data: me } = useMe();

  const canEditProfile = canEditFacilityBasicInfo(me, locationData);

  const innerText = canEditProfile ? t("edit_profile") : t("view_profile");

  // If the user can edit the profile, show the button to open the modal
  if (canEditProfile) {
    return (
      <button
        className="btn btn-border"
        onClick={() => onOpenModal(accordionEventKey)}
      >
        {innerText}
      </button>
    );
  }

  // If the user cannot edit the profile, and there is no gbpLink, return nothing
  if (!gbpLink) {
    return null;
  }

  // If the user cannot edit the profile, and there is a gbpLink, show the link
  return (
    <a
      href={gbpLink}
      className="btn btn-border"
      target="_blank"
      rel="noreferrer"
      onClick={() => {
        ReactGA.event({
          category: "GBP Link",
          action: "Click to GBP",
          label: "profile",
        });
      }}
    >
      {innerText}
    </a>
  );
};
